/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common';
import './model';
import '../../client/status';
import './service';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "buyer": {
        "nested": {
          "rewards": {
            "nested": {
              "rewardCode": {
                "nested": {
                  "service": {
                    "nested": {
                      "GetForSquareBuyerPersonRequest": {
                        "fields": {
                          "ownerToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ownerTokenType": {
                            "type": ".squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonRequest.TokenType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "rewardName": {
                            "type": ".squareup.rewards.RewardName",
                            "id": 3,
                            "rule": "optional"
                          },
                          "maxUses": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "rewardProgram": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "rewardCodePurpose": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "TokenType": {
                            "values": {
                              "UNKNOWN": 0,
                              "SQUARE": 1,
                              "MERCHANT": 2,
                              "PARTNER": 3,
                              "SQUARE_BUYER_PERSON": 4
                            }
                          }
                        }
                      },
                      "GetForSquareBuyerPersonResponse": {
                        "fields": {
                          "status": {
                            "type": ".squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonResponse.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "rewardCode": {
                            "type": ".squareup.rewards.rewardCode.RewardCode",
                            "id": 2,
                            "rule": "optional"
                          },
                          "mobileStatus": {
                            "type": ".squareup.client.Status",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "UNKNOWN": 0,
                              "USER_NOT_ELIGIBLE": 1,
                              "FAILURE": 2,
                              "SUCCESS": 3,
                              "INVALID_REQUEST": 4
                            }
                          }
                        }
                      },
                      "RewardCodeService": {
                        "methods": {
                          "GetForSquareBuyerPerson": {
                            "requestType": ".squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonRequest",
                            "responseType": ".squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonResponse"
                          },
                          "CustomizeRewardCode": {
                            "requestType": ".squareup.rewards.rewardCode.service.CustomizeRewardCodeRequest",
                            "responseType": ".squareup.rewards.rewardCode.service.CustomizeRewardCodeResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForSquareBuyerPersonRequest && !$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForSquareBuyerPersonRequest?.nested?.TokenType && !$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForSquareBuyerPersonResponse && !$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForSquareBuyerPersonResponse?.nested?.Status && !$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.RewardCodeService) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE GetForSquareBuyerPersonRequest @ squareup/rewards/rewardCode/buyer_service.proto at 26:1
 */
export const GetForSquareBuyerPersonRequest = $root.lookupType('squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonRequest');
fixType(GetForSquareBuyerPersonRequest);
Builder.createAndAttachToType(GetForSquareBuyerPersonRequest);
/**
 * SOURCE TokenType @ squareup/rewards/rewardCode/buyer_service.proto at 27:3
 */
GetForSquareBuyerPersonRequest.TokenType = $root.lookupEnum('squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonRequest.TokenType').values;
/**
 * SOURCE GetForSquareBuyerPersonResponse @ squareup/rewards/rewardCode/buyer_service.proto at 46:1
 */
export const GetForSquareBuyerPersonResponse = $root.lookupType('squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonResponse');
fixType(GetForSquareBuyerPersonResponse);
Builder.createAndAttachToType(GetForSquareBuyerPersonResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/buyer_service.proto at 47:3
 */
GetForSquareBuyerPersonResponse.Status = $root.lookupEnum('squareup.buyer.rewards.rewardCode.service.GetForSquareBuyerPersonResponse.Status').values;
/**
 * SOURCE RewardCodeService @ squareup/rewards/rewardCode/buyer_service.proto at 14:1
 */
export const RewardCodeService = $root.lookupService('squareup.buyer.rewards.rewardCode.service.RewardCodeService');
